import { WorkshopRepository } from '@/core/workshop/domain/WorkshopRepository.ts'
import { WorkshopsClient } from 'online-customer-services-ts'
import { Workshop, WorkshopBrand } from '@/core/workshop/domain/Workshop.ts'

export class WorkshopRepositoryBackendClient implements WorkshopRepository {
  private readonly workshopClient: WorkshopsClient

  constructor(url: string) {
    this.workshopClient = new WorkshopsClient(url)
  }

  async getWorkshops(hostId: string): Promise<Workshop[]> {
    const workshops = await this.workshopClient.getMarketWorkshops(hostId)

    return workshops.map((workshop) => {
      return {
        id: workshop.id ?? NaN,
        name: workshop.name ?? '',
        addressPart1: workshop.addressPart1 ?? '',
        addressPart2: workshop.addressPart2 ?? '',
        startingWorkHour: workshop.startingWorkHour ?? '07:00',
        endingWorkHour: workshop.endingWorkHour ?? '16:00',
        schedulerTimeSlot: workshop.schedulerTimeSlot ?? NaN,
        brands: workshop.brands?.map((brand) => {
          return {
            code: brand.code ?? '',
            serviceId: brand.serviceId ?? NaN
          }
        }) as WorkshopBrand[],
        latitude: workshop.latitude ?? NaN,
        longitude: workshop.longitude ?? NaN,
        timeZoneId: workshop.timeZoneId ?? '',
        noWorkingWeekDays: workshop.noWorkingWeekDays?.map((day) => day) ?? [],
        simaId: workshop.simaId ?? NaN,
        idInEnterprise: workshop.idInEnterprise ?? NaN,
        daysOfMarginToRequest: workshop.daysOfMarginToRequest ?? 0,
        phone: workshop.phone ?? '',
        redirectUrl: workshop.redirectUrl ?? ''
      }
    })
  }
}
